import * as React from "react";
const SvgFiRrRollerCoaster = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22 13h-1a7.95 7.95 0 0 1-3.204-.67A9.98 9.98 0 0 0 21 5c0-2.757-2.243-5-5-5s-5 2.243-5 5a9.97 9.97 0 0 0 3.204 7.33A7.95 7.95 0 0 1 11 13c-4.411 0-8-3.589-8-8a1 1 0 1 0-2 0v18a1 1 0 1 0 2 0V10.993a10 10 0 0 0 2 2.002V23a1 1 0 1 0 2 0v-8.836a10 10 0 0 0 2 .635V23a1 1 0 1 0 2 0v-8q1.03-.002 2-.201V23a1 1 0 1 0 2 0v-8.835a10 10 0 0 0 1-.507 10 10 0 0 0 1 .507V23a1 1 0 1 0 2 0v-8.201A10 10 0 0 0 21 15v8a1 1 0 1 0 2 0v-9a1 1 0 0 0-1-1m-6-1.759A8 8 0 0 1 13 5c0-1.654 1.346-3 3-3s3 1.346 3 3a7.99 7.99 0 0 1-3 6.241"
    />
  </svg>
);
export default SvgFiRrRollerCoaster;
